/** 新手静态引导：常量与 session key */

export const ONBOARDING_GUIDE_ROUTE_NAME = "onboarding-guide";

export const ONBOARDING_SESSION_KEY = "holopix:onboarding-guide-session";

/** 第二段引导完成标识（customStorage，与 userCollectModalKey 分离） */
export const ONBOARDING_PART2_DONE_KEY = "onboardingGuidePart2Completed";

/** 问卷提交后与 full 8 步入口共用路由 query.flow */
export type OnboardingGuideFlow = "survey" | "full";

export const TEMPLATE_COMPLETE_EVENT = "onboarding:template-complete";

/** 静态引导选「一键成稿」后，唤起现网 Finish 推荐模型弹窗（携带已交卷的 modelList，不再二次 addUserTagNew） */
export const ONBOARDING_OPEN_LEGACY_FINISH_EVENT = "onboarding:openLegacyFinish";

/** 选功能点「上一步」：回到问卷 Step3（带已填快照） */
export const ONBOARDING_RESUME_SURVEY_EVENT = "onboarding:resumeSurvey";

/** 回到问卷期间抑制 board-all 拉起完整 8 步 */
export const ONBOARDING_RESUME_SURVEY_FLAG = "holopix:onboarding-resume-survey";

export function isOnboardingGuideRouteName(routeName: string | symbol | null | undefined): boolean {
  return routeName === ONBOARDING_GUIDE_ROUTE_NAME;
}
